import { OPERATIONS } from 'constants';
import menuItems from 'menu-items';

const excludedIds = menuItems.items.reduce((acc, item) => {
  if (item.exclude) {
    acc.push(...item.children.map((m) => m.id));
  }
  return acc;
}, []);

function hasPermission(permission = 'home', permissions = {}, operation = 'view') {
  if (excludedIds.includes(permission) && operation !== OPERATIONS.SMALL_TEAMS) return true;
  return permissions[permission] ? permissions[permission][operation] === true : false;
}

export default hasPermission;
